import * as React from "react";
import { toINR } from "../../../../service/numberFormat";

export interface IHoldEqUsablePopupProps {
	data: any;
	onClose: () => void;
}

const HoldEqUsablePopup: React.FC<IHoldEqUsablePopupProps> = props => {
	return (
		<div className="hold_popup">
			<div>
				<button className="cls" onClick={props.onClose}>
					<i className="edel-icon-close"></i>
				</button>
			</div>
			<div className="content_lr_padding heading_cont btmborder">
				<h2 className="title">{props.data.trdSym}</h2>
				<h3 className="sub_title">{props.data.cpName ? props.data.cpName : props.data.dpName}</h3>
			</div>
			<div className="content_lr_padding">
				<div className="content_tb_padding btmborder bold">
					<div className="row">
						<span>Holding Value</span>
						<span>₹{toINR(props.data.hdgVl)}</span>
					</div>
					<div className="row">
						<span>LTP</span>
						<span>₹{toINR(props.data.ltp)}</span>
					</div>
				</div>
				<div className="content_tb_padding btmborder bold">
					<div className="row">
						<span>Total Normal Quantity</span>
						<span>{props.data.cncRmsHdg ? toINR(props.data.cncRmsHdg.totQty) : "—"}</span>
					</div>
					<div className="row">
						<span>Total MTF Quantity</span>
						<span>{props.data.mtfRmsHdg ? toINR(props.data.mtfRmsHdg.totQty) : "—"}</span>
					</div>
				</div>
				<div className="content_tb_padding">
					<div className="row">
						<span>Normal Quantity</span>
						<span>{props.data.cncRmsHdg ? toINR(props.data.cncRmsHdg.qty) : "—"}</span>
					</div>
					<div className="row">
						<span>Normal MTF Quantity</span>
						<span>{props.data.mtfRmsHdg ? toINR(props.data.mtfRmsHdg.qty) : "—"}</span>
					</div>
					<div className="row">
						<span>T1 Quantity</span>
						<span>{props.data.cncRmsHdg ? toINR(props.data.cncRmsHdg.t1HQty) : "—"}</span>
					</div>
					<div className="row">
						<span>T1 MTF Quantity</span>
						<span>{props.data.mtfRmsHdg ? toINR(props.data.mtfRmsHdg.t1HQty) : "—"}</span>
					</div>
					<div className="row">
						<span>Used Quantity</span>
						<span>{props.data.cncRmsHdg ? toINR(props.data.cncRmsHdg.usdQty) : "—"}</span>
					</div>
					<div className="row">
						<span>Used MTF Quantity</span>
						<span>{props.data.mtfRmsHdg ? toINR(props.data.mtfRmsHdg.usdQty) : "—"}</span>
					</div>
					<div className="row">
						<span>Normal Holding Value</span>
						<span>{props.data.cncRmsHdg ? toINR(props.data.cncRmsHdg.hdgVl) : "—"}</span>
					</div>
					<div className="row">
						<span>MTF Holding Value</span>
						<span>{props.data.mtfRmsHdg ? toINR(props.data.mtfRmsHdg.hdgVl) : "—"}</span>
					</div>
				</div>
				<div className="btn_cont">
					<button className="btn buy">Buy</button>
					<button className="btn sell">Sell</button>
				</div>
			</div>
		</div>
	);
};

export default HoldEqUsablePopup;
